export const sportsQueryKeys = {
  all: ['sports'] as const,
  lists: () => [...sportsQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...sportsQueryKeys.lists(), { filters }] as const,
};
